
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline, TimelineLite} from "gsap";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";

export class HarlequinScatterCollector implements GameRoundPresentation {

    private static HAS_UPDATED_THIS_ROUND:boolean = false;
    private _scattersCollected:number;
    private _scattersCollectedAfter:number;
    private _reelId:number;
    private _scatterPositions:number [];
    private _extraScatterThisFSSpin:number [];


    private _tl:TimelineLite;
    private _duration:number = 0.2;
    private _hasWin:boolean = false;
    private _reset:boolean = false;
    private _fsStartReset:boolean = false;
    private _freespinPlayed:number = 0;
    private _isFreespin:boolean = false;
    private _isFreespinNext:boolean = false;
    private _toMode:string;
    private _fromMode:string;


    // TODO: Remove anything FS collected excdpt first spin related

    constructor(reelId:number, reset:boolean = false, fsStartReset:boolean = false) {
        this._reelId = reelId;
        this._reset = reset;
        this._fsStartReset = fsStartReset;
    }

    public getAnimation():Timeline {
        const tl = new TimelineLite();
        //debugger;

        if(this._fsStartReset && this._freespinPlayed <= 0) {
            //console.log("FS START RESETTER!");
            //tl.add(() => HarlequinGameModuleConfig.harlequinScatterCollectorView.resetIndicators());
        }

        if(this._reset && !this._isFreespin /*&& this._scattersCollected <= 0*/) { // Move to FS collector?
            //console.log("FS RESETTER!");
            HarlequinGameModuleConfig.harlequinScatterCollectorView.resetIndicators();
            //tl.add(() => HarlequinGameModuleConfig.harlequinScatterCollectorView.resetIndicators());
        }

        if(!this._reset && this._hasWin && this._scatterPositions[this._reelId] > -1) {
            // TODO: aint gonna work, can be updated up to 3 times per round, need to be broken out to singleton in any case

            /*if(!HarlequinGameModuleConfig.harlequinScatterCollectorView.isLocked && !HarlequinGameModuleConfig.harlequinSignView.triggered) {
                //tl.add(() => HarlequinGameModuleConfig.harlequinScatterCollectorView.litNext(), 0.2);
                if(this._isFreespin) {
                    tl.add(() => HarlequinGameModuleConfig.harlequinScatterCollectorView.litNext(), 0.2);
                }
            }*/

            if(this._scattersCollected >= 3) {

                let nrOfScattersThisRound:number = 0;
                this._scatterPositions.forEach((value) => {
                    if(value > -1) {
                        nrOfScattersThisRound++;
                    }
                });
                const collectedBefore = this._scattersCollected - nrOfScattersThisRound;
                const requiredToTrigger:number = 3 - collectedBefore;

                let count: number = 0;
                this._scatterPositions.forEach((value:number, index:number) => {

                    if(value > -1) {
                        count++;
                    }

                    if(count === requiredToTrigger && this._reelId === index && value > -1) {
                        tl.add([
                            /*(HarlequinGameModuleConfig.harlequinScatterCollectorView.isLocked) ? () => {
                            } : HarlequinGameModuleConfig.harlequinSignView.setBonusSignAnimation("bonusSignTurningActive", () => {
                                HarlequinGameModuleConfig.harlequinSignView.setBonusSignAnimation("bonusSignActive");
                            }),*/
                            (HarlequinGameModuleConfig.harlequinScatterCollectorView.isLocked) ? () => {
                                // baseGamaeToBonusGameWon
                            } : HarlequinGameModuleConfig.harlequinSignView.enterMode(this._fromMode, this._toMode)/*HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGamaeToBonusGameWon", 0, false, (entry:PIXI.spine.core.TrackEntry) => {
                                if(entry.animation.name === "baseGamaeToBonusGameWon") {
                                    //HarlequinGameModuleConfig.harlequinSignView.playSignSpine("bonusGameWonToBonusGame");
                                }
                                //HarlequinGameModuleConfig.harlequinSignView.setBonusSignAnimation("bonusSignActive");
                            })*/
                            //,
                            //() => HarlequinGameModuleConfig.harlequinScatterCollectorView.lock()
                        ], "+=0.2");
                        HarlequinGameModuleConfig.harlequinSignView.triggered = true;
                    }

                });

            }

        }

        if(this._reset && this._isFreespin && this._reelId === 4 && this._scattersCollectedAfter === 2) {
            /*tl.add(() => {
                HarlequinGameModuleConfig.harlequinScatterCollectorView.resetIndicators();
            }, 0.4);*/
        }

        this._tl = tl;
        return this._tl;
    }

    abort(isActive: boolean, data: HarlequinParsedGameData): Timeline | null {
        if(isActive && this._tl) {
            GameRoundManager.detachAndPlayTimeline(this._tl)
        }
        return null;
    }

    protected getBaseAnimation():Timeline {
        const tl:TimelineLite = new TimelineLite();

        return tl;
    }

    protected getFsAnimation():Timeline {
        const tl:TimelineLite = new TimelineLite();

        return tl;
    }

    public prepare(data:HarlequinParsedGameData) {
        HarlequinScatterCollector.HAS_UPDATED_THIS_ROUND = false;
        this._hasWin = (data.scattersCollected > 0);
        this._isFreespin = data.mode === GameMode.FREESPIN || data.mode === "WILD_RESPIN_FS";
        this._isFreespinNext = ((data.mode === GameMode.NORMAL || data.mode === "WILD_RESPIN") && data.nextMode === GameMode.FREESPIN);
        this._scattersCollected = data.scattersCollected;
        this._scattersCollectedAfter = data.scattersCollectedFSAfter;
        this._scatterPositions = (data.scatterPositions)? data.scatterPositions : [-1,-1,-1,-1,-1];
        this._extraScatterThisFSSpin = (data.extraScatterThisFSSpin)? data.extraScatterThisFSSpin : [-1,-1,-1,-1,-1];
        this._fromMode = data.mode;
        this._toMode = data.nextMode;


        this._freespinPlayed = data.freespinPlayed;
    }

}